export var SnapshotSelectorMode;
(function (SnapshotSelectorMode) {
    SnapshotSelectorMode["SNAPSHOT_SELECTOR_MODE_UNSPECIFIED"] = "SNAPSHOT_SELECTOR_MODE_UNSPECIFIED";
    SnapshotSelectorMode["SNAPSHOT_SELECTOR_MODE_RANGE"] = "SNAPSHOT_SELECTOR_MODE_RANGE";
    SnapshotSelectorMode["SNAPSHOT_SELECTOR_MODE_MANUAL"] = "SNAPSHOT_SELECTOR_MODE_MANUAL";
})(SnapshotSelectorMode || (SnapshotSelectorMode = {}));
